import React from "react";
import { Link } from "react-router-dom";

interface Props { }
const NotFound: React.FC<Props> = () => {

  return (
    <div className="">
      <h2>Pagina non trovata</h2>
      <p>
        Vai a <Link to="/">Homepage</Link>
      </p>
    </div>
  );
};
export default NotFound;
